import { Moment } from 'moment';
import { SystemUser } from './system-user';

export class SchoolComment {

    constructor(
        public title: string,
        public body: string,
        public created?: Moment,
        public createdBy?: SystemUser,
        public lastModified?: Moment,
        public id?: number,
        public isDeleted?: boolean
    ){}
}
